module.exports = __webpack_public_path__ + "img/not_logged_in.41907da1.svg";